// extracted by extract-css-chunks-webpack-plugin
module.exports = {"detail":"detail_xrwSi","content":"content_lpxYV","title":"title_HOr9P","article":"article_8VyVU","page":"page_MyVwR"};